/*
 * AMP collection and search endpoints may return fully qualified URLs for external clients to be
 * able to point back to predtermined web environments. On web, we need to remove theses to re-establish
 * path relativity and for ephemerial environments
 */

import UrlParse from 'url-parse';

const webAmpHosts = [
  'beta.iheart.com',
  'dev.iheart.com',
  'iheart.com',
  'sandbox.iheart.com',
  'stage.iheart.com',
  'www.iheart.com',
];

export default function trimAmpWebHost(ampUrl: string) {
  const url = new UrlParse(ampUrl);

  return webAmpHosts.includes(url.host) ?
      url.pathname + url.query // TODO: replace with just url.path when it is added to url-parse
    : ampUrl;
}
